import {
  IonCard,
  IonItem,
  IonList,
  IonGrid,
  IonCardHeader,
  IonContent,
  IonPage,
  IonSelect,
  IonSelectOption,
  useIonViewWillEnter,
  IonCardTitle,
  IonCardContent,
  IonCol,
  IonRow,
  IonButton,
} from "@ionic/react";
import { useParams } from "react-router";
import { Preferences } from "@capacitor/preferences";
import { BewohnerZusatzstoffe } from "../components/_funktionen/bewohner_zusatzstoffe";
import { RezeptZusatzstoffe } from "../components/_funktionen/rezept_zusatzstoffe";
import { Servierhinweise } from "../components/_funktionen/servierhinweise";
import { Doughnut } from "react-chartjs-2";
import { mk_ion_header } from "../functions/mk_ion_header";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { ButtonBackToSpeisekarte } from "../components/_funktionen/button_back_to_speisekarte";
import { send_data } from "../functions/send_data";

export default function Mittag() {
  const { appServer, appBewohnerSollId, appBewohnerSollBezeichnung, appSollReloadAuswahlChange, appToken } = useContext(DataContext);
  const [auswahl, setAuswahl] = useState<any>([]);
  const [bewohnerBemerkung, setBewohnerBemerkung] = useState<any>();
  const [ contentNaehrwerte, setContentNaehrwerte] = useState<any>( <IonItem lines="none">Laden ...</IonItem>);
  const [komponenten, setKomponenten] = useState<any>([]);
  const [naehrwerte, setNaehrwerte] = useState<any>({ BE: 0, EW: 0, Fett: 0, KH: 0, Kcal: 0 });
  const [speiseplan, setSpeiseplan] = useState<any>();
  const [angebotMenue1, setAngebotMenue1] = useState<any>();
  const [angebotMenue2, setAngebotMenue2] = useState<any>();
  const [angebotMenue3, setAngebotMenue3] = useState<any>();
  const [angebotOptionen, setAngebotOptionen] = useState<any>();

  let rezepte_bestellt: any = {} ;

  const bilder: any = { 1: '', 2: '' , 3: '' } ;

  const { datumsql } = useParams<any>();
  let datum_info = `- ${new Date(datumsql).toLocaleDateString("de-DE", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}`;

  const doughnutChartDataKcal = {
    labels: ["Gewählt", "Tagesbedarf"],
    datasets: [
      {
        label: "Kcal",
        backgroundColor: ["orange", "green"],
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        data: [naehrwerte.Kcal, 1900 - naehrwerte.Kcal],
      },
    ],
  };

  const doughnutChartDataEW = {
    labels: ["Kohlenhydrate", "Eiweiß", "Fett"],
    datasets: [
      {
        label: "Kcal",
        backgroundColor: ["orange", "green", "red"],
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        data: [naehrwerte.KH, naehrwerte.EW, naehrwerte.Fett],
      },
    ],
  };

  function addKomponente(rezept: any, my_element: any = '') {
    let alt_komponenten = komponenten;
    let my_menge: any = 0 ;
    if( my_element === '' ) {
      my_menge = ( alt_komponenten[rezept] * 1 ) === 1 ? 0 : 1 ;
    }
    if( typeof my_element === 'object' ) {
      my_menge = my_element.value;
    }
    if( parseInt( my_menge ) === 0 && rezepte_bestellt.hasOwnProperty( rezept ) ) {
      delete rezepte_bestellt[ rezept ] ;
    }
    alt_komponenten[rezept] = my_menge;
    send_data(appServer, appToken, appBewohnerSollId, rezept, my_menge, 2, datumsql);
    setKomponenten(alt_komponenten);
    appSollReloadAuswahlChange(true);
    setAngebotMenue1(mk_angebot_menue("1"));
    setAngebotMenue2(mk_angebot_menue("2"));
    setAngebotMenue3(mk_angebot_menue("3"));
    setAngebotOptionen(mk_angebot_optionen());
  }

  const checkBewohner = async () => {
    const { value } = await Preferences.get({ key: "senioren.bewohner" });
    if (value) {
      JSON.parse(value).forEach((entry: any) => {
        if (entry.betriebe_bewohner_id === appBewohnerSollId) {
          setBewohnerBemerkung([entry.bewohner_bemerkung, entry.bewohner_sonderkost].join(" "));
        }
      });
    }
  };

  function eraseBestellung() {
    if( ! speiseplan ) {
      alert( 'Fehler: Kein Speiseplan ermittelbar' ) ;
      return ;
    }
    const do_erase = ( entry: any ) => {
      if ( entry.speiseplan_tag != datumsql ) return ;
      if ( entry.betriebe_speiseplaene_zeit !== "2" ) return ;
      alt_komponenten[entry.rezepte_id] = "0";
//      send_data(appServer, appToken, appBewohnerSollId, entry.rezepte_id, "0", 2, datumsql);
    }
    let alt_komponenten = komponenten;
    speiseplan.map((entry: any) => {
      do_erase( entry ) ;
    }) ;
    rezepte_bestellt = {} ;
    //send_data(appServer, appToken, appBewohnerSollId, 999999, "0", 2, datumsql);
    setKomponenten(alt_komponenten);
    setAngebotMenue1(mk_angebot_menue("1"));
    setAngebotMenue2(mk_angebot_menue("2"));
    setAngebotMenue3(mk_angebot_menue("3"));
  }

  function selectMenueClickImage(kategorie:any){
    if( ! speiseplan ) {
      alert( 'Fehler: Kein Speiseplan ermittelbar' ) ;
      return ;
    }
    console.log('starte löschung')
    eraseBestellung() ;
    console.log('ende löschung')
    let alt_komponenten = komponenten;

    speiseplan.map((entry: any) => {
      if (
        entry.speiseplan_tag === datumsql &&
        entry.speiseplan_kategorie === kategorie &&
        entry.betriebe_speiseplaene_zeit === "2"
      )
        {
          alt_komponenten[entry.rezepte_id] = "1";
         // send_data(appServer, appToken, appBewohnerSollId, entry.rezepte_id, "1", 2, datumsql);
          //addKomponente(entry.rezepte_id, 1);
        }   
      })
      speiseplan &&
      speiseplan.map((entry: any) => {
        if (
          entry.speiseplan_tag === datumsql &&
          entry.speiseplan_kategorie === "3" &&
          entry.betriebe_speiseplaene_zeit === "2"
        )
          {
            alt_komponenten[entry.rezepte_id] = "1";
           // send_data(appServer, appToken, appBewohnerSollId, entry.rezepte_id, "1", 2, datumsql);
            //addKomponente(entry.rezepte_id, 1);
            
          }
      })
      setKomponenten(alt_komponenten);
      appSollReloadAuswahlChange(true);
      setAngebotMenue1(mk_angebot_menue("1"));
      setAngebotMenue2(mk_angebot_menue("2"));
      setAngebotMenue3(mk_angebot_menue("3"));
      setAngebotOptionen(mk_angebot_optionen());
  }

  function mk_view_komponente( kategorie: any, bild: any, bezeichnung: any, gramm: any, allergene: any, rezept: any, komponenten: any ){
    let my_bild = bild === 'kein_bild.png' ? 'keinBild.jpeg' : 'rezepte/' + bild ;
    if( my_bild === 'rezepte/undefined' ) my_bild = 'keinBild.jpeg' ;
    bilder[ kategorie ] = 'konfig/evkw/bilder/' + my_bild;
    let my_color = "" ;
    let my_menge = "0" ;

    if( komponenten[rezept] > 0 && ! rezepte_bestellt.hasOwnProperty( rezept ) ) {
      rezepte_bestellt[ rezept ] = kategorie ;
    }

    if( rezepte_bestellt.hasOwnProperty( rezept ) && rezepte_bestellt[ rezept ] === kategorie ) {
      my_color = "success" ;
      my_menge = komponenten[rezept] ;
    }

    return(
      <>
        <IonItem slot="start" lines="none">
          {bezeichnung + " (" + gramm + "g)"}
          <br />
          {
            // Nährwerte ...
          }
          <RezeptZusatzstoffe rezepte_zusatzstoffe={allergene} />
        </IonItem>
        <IonItem slot="end" color={my_color}>
          {
            ( rezepte_bestellt.hasOwnProperty( rezept ) && rezepte_bestellt[ rezept ] !== kategorie )
              ? <b>Komponente bereits bestellt in Menü { rezepte_bestellt[ rezept ] } (Mengenänderung dort vornehmen)</b>
              :
                <>
                  Portion:
                  <IonSelect
                    onIonChange={(e) => {
                      console.log('IonChange getriggert')
                      if (e.currentTarget !== null) addKomponente(rezept, e.currentTarget);
                      appSollReloadAuswahlChange(true);
                    }}
                    value={my_menge}
                    ok-text="speichern"
                    cancel-text="abbrechen"
                  >
                    <IonSelectOption value={"0"}>0</IonSelectOption>
                    <IonSelectOption value={"1"}>1</IonSelectOption>
                    <IonSelectOption value={"0.5"}>1/2</IonSelectOption>
                    <IonSelectOption value={"1.5"}>1 1/2</IonSelectOption>
                  </IonSelect>
                </>
          }
        </IonItem>
      </>
    ) ;
  }

  function mk_angebot_menue(kategorie: any) {
    let my_komponenten = (
      speiseplan &&
      speiseplan.map((entry: any, index: number) => {
        return (
          <div key={"view_menue_kat" + kategorie + '_' + index}>
            {entry.speiseplan_tag === datumsql &&
            entry.speiseplan_kategorie === kategorie &&
            entry.betriebe_speiseplaene_zeit === "2" ? (
              <>
                { mk_view_komponente( kategorie, entry.tag_bild, entry.rezepte_bezeichnung, entry.ausgabemenge*entry.speiseplan_portion*entry.speiseplan_faktor, entry.rezepte_zusatzstoffe, entry.rezepte_id, komponenten ) }
              </>
            ) : (
              ""
            )}
          </div>
        );
      })
    );
    return(
      <IonCol key={"view_menue_kat_" + kategorie}>
        <img src={appServer + "/" + bilder[ kategorie ]} alt="kein Bild vorhanden" onClick={()=>{console.log('Bild geklickt');selectMenueClickImage( kategorie )}}></img>
        <IonList>
          { my_komponenten }
        </IonList>
      </IonCol>
    ) ;
  }

  function mk_angebot_optionen() {
    update_naehrwerte() ;
    return (
      <div key={"view_menue_optionen"}>
        <IonItem lines="none">
          <IonButton color={komponenten[ 0 ] > 0 ? 'success' : ''} onClick={ () => { eraseBestellung(); addKomponente(0); } } size='large'>kostfrei</IonButton>
          <IonButton color={komponenten[ 4 ] > 0 ? 'success' : ''} onClick={ () => addKomponente(4) } size='large'>passiert</IonButton>
        </IonItem>
      </div>
    );
  }

  function update_naehrwerte( called_at = '' ) {
    let komponenten_bestellt = Object.keys( komponenten ).filter( ( key: string ) => parseFloat( komponenten[ key ] ) !== 0 ) ;
    var my_data: any = {
      BE: 0,
      EW: 0,
      Fett: 0,
      KH: 0,
      Kcal: 0,
    };
    if( speiseplan ) {
      speiseplan.map((elementInArray: any) => {
        if (elementInArray.speiseplan_tag === datumsql && elementInArray.betriebe_speiseplaene_zeit === "2" && komponenten_bestellt.includes( elementInArray.rezepte_id )) {
          let my_menge = parseFloat(komponenten[elementInArray.rezepte_id] ? komponenten[elementInArray.rezepte_id] : 0) ;
          my_data.BE += my_menge * parseFloat(elementInArray.naehrwerte_array.BE);
          my_data.EW += my_menge * parseFloat(elementInArray.naehrwerte_array.EW);
          my_data.Fett += my_menge * parseFloat(elementInArray.naehrwerte_array.Fett);
          my_data.Kcal += my_menge * parseFloat(elementInArray.naehrwerte_array.Kcal);
          my_data.KH += my_menge * parseFloat(elementInArray.naehrwerte_array.KH);
        }
      });
      // console.log( 'ZUGGA 2' , called_at, Object.keys( my_data ).map( key => key + ': ' + my_data[ key ]  ).join( ', ' )  ) ;
      setNaehrwerte( my_data );
    }
  }

  useEffect(() => {
    setAngebotMenue1(mk_angebot_menue("1"));
    setAngebotMenue2(mk_angebot_menue("2"));
    setAngebotMenue3(mk_angebot_menue("3"));
    setAngebotOptionen(mk_angebot_optionen());
  }, [komponenten, speiseplan]);

  useEffect(() => {
    let alt_komponenten: any = [];
    auswahl &&
      auswahl.map((gewaehltInArray: any) => {
        if (gewaehltInArray.bewohner_verzehr_zeit === "2") {
          if (gewaehltInArray.bewohner_verzehr_tag === datumsql) alt_komponenten[gewaehltInArray.rezepte_id] = gewaehltInArray.bewohner_verzehr_menge;
        }

        return true;
      });
    setKomponenten(alt_komponenten);
    setAngebotMenue1(mk_angebot_menue("1"));
    setAngebotMenue2(mk_angebot_menue("2"));
    setAngebotMenue3(mk_angebot_menue("3"));
    setAngebotOptionen(mk_angebot_optionen());
  }, [auswahl]);

  useEffect( () => {
    let my_content = (
      <>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Kcal</IonCardTitle>
                </IonCardHeader>
                <Doughnut data={doughnutChartDataKcal} options={{ maintainAspectRatio: true }} />
              </IonCard>
            </IonCol>
            <IonCol>
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Zusammensetzung</IonCardTitle>
                </IonCardHeader>
                <Doughnut data={doughnutChartDataEW} options={{ maintainAspectRatio: true }} />
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonItem>BE {Intl.NumberFormat("de-DE", { maximumSignificantDigits: 2 }).format(naehrwerte.BE)}</IonItem>
        <IonItem>Kcal {naehrwerte.Kcal}</IonItem>
        <IonItem>Kohlenhydrate {naehrwerte.KH}g</IonItem>
        <IonItem>Fett {naehrwerte.Fett}g</IonItem>
        <IonItem>Eiweiß {naehrwerte.EW}g</IonItem>
      </>
    ) ;
    setContentNaehrwerte( my_content ) ;
  }, [ naehrwerte ] )

  useIonViewWillEnter(() => {
    const get_preference = async (key: string) => {
      const { value } = await Preferences.get({ key: "senioren." + key });
      if (!value) {
        return null;
      } else return value;
    };
    get_preference("token").then(() => {
      get_preference("mittag").then((res: any) => {
        setSpeiseplan(JSON.parse(res));
      });
      get_preference("auswahl").then((res: any) => {
        setAuswahl(JSON.parse(res));
      });
    });
    checkBewohner();
  });

  return (
    <IonPage>
      {mk_ion_header(`Mittag ${appBewohnerSollBezeichnung} ${datum_info}`)}
      <IonContent fullscreen>
        {mk_ion_header(`Mittag ${appBewohnerSollBezeichnung} ${datum_info}`, "large")}
        <ButtonBackToSpeisekarte />
        <IonItem class="section_anmerkungen">
          <Servierhinweise bewohnerid={appBewohnerSollId} zeit="Mittag" />
          <BewohnerZusatzstoffe bewohnerid={appBewohnerSollId} />
          {bewohnerBemerkung}
        </IonItem>
        <IonCard class="section_menues, ion-text-center">
          <IonGrid>
            <IonRow>
              {angebotMenue1 && angebotMenue1}
              {angebotMenue2 && angebotMenue2}
              {angebotMenue3 && angebotMenue3}
              <IonCol>
                <h1>Sonderkomponenten</h1>
                <IonList>{angebotOptionen && angebotOptionen}</IonList>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCard>
        <IonCard class="section_naehrwerte_doughnut">
          <IonCardHeader>
            <IonCardTitle>Nährwerte</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            { contentNaehrwerte }
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
}
